var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.isAdviser())?[_c('adviser-dashboard')]:[_c('investor-dashboard')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }